import React from 'react';
import './color-picker-field.css';

class ColorPickerField extends React.Component {
  render() {
    const { label, value, handleChange } = this.props;
    return (
      <div className='color-picker-field' data-cy={`color-picker-field-${label.replace(" ", "").toLowerCase()}`}>
        <input type="text" className='color-picker-field-input' value={value} onChange={handleChange}/>
        <label> {label} </label>
      </div>
    );
  }
}

export default ColorPickerField;



// WEBPACK FOOTER //
// ./src/components/common/form/elements/color-picker-field.jsx